export const HelloSellerAppH5Config = {
  iosAppStoreUrl:
    'https://apps.apple.com/cn/app/%E5%9C%86%E9%A2%86%E4%B9%8B%E5%AE%B6-%E5%9C%86%E9%A2%86%E8%B6%85%E7%BA%A7%E4%B8%AA%E4%BD%93%E5%8D%96%E5%AE%B6%E7%89%88/id1636247066',
  androidApkUrl: 'https://www.yuanling.com/app/%E5%9C%86%E9%A2%86%E4%B9%8B%E5%AE%B6APP.apk',
  shareButtonLabel: '打开圆领之家',
  downloadButtonLabel: '下载圆领之家',
  documentTitle: '打开圆领之家',
} as const;
